import { render } from "./ScrollspyPage.vue?vue&type=template&id=422093f8&ts=true"
import script from "./ScrollspyPage.vue?vue&type=script&lang=ts"
export * from "./ScrollspyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__